// extracted by mini-css-extract-plugin
module.exports = {"container":"drawerHeader_container__vY9RN","container_hasImg":"drawerHeader_container_hasImg__2MqQq"};